exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.upgrade-plan-container .btn-upgrade {\n  background: #333;\n  border-radius: 20px;\n  font-weight: 600;\n  line-height: 22px;\n  text-transform: uppercase;\n  font-size: 17px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/vue-loader/lib??vue-loader-options!./resources/assets/js/components/upgradePlan.vue?vue&type=style&index=0&lang=css&
// module id = na42
// module chunks = 35